import {makeStyles} from '@material-ui/core';

export const useInfoListStyle = makeStyles(theme => ({
	root: {
		fontSize: 'small',
		width: '100%',
	},
	date: {
		minWidth: 75,
		verticalAlign: 'top',
	},
	msg: {
		paddingBottom: theme.spacing(1),
	},
}))